// function checkNetworkResponse (url: string) {
//   return fetch(url, { method: 'HEAD' }).then(res => res.ok).catch(() => false)
// }

export async function getFallbackUrl (url:string) {
  // if (await checkNetworkResponse(url)) {
  //   return url
  // }
  const rgxSize = /_[^\W_]+(?=\.|$)/
  const size = url.match(rgxSize)?.[0]
  if (!size || size === '_0') return url
  const fallback = url.replace(rgxSize, '_S')
  return fallback
}
